<!-- splash screen -->
<div #splashScreen id="splash-screen">
  <img class="adn-logo" [src]="logo" alt="spotside ads logo"/>
</div>
